import React, { useEffect, useState } from 'react';
import { Modal, Input, Icon, message, Button, Spin, Popover } from "antd";
import Masonry from "react-masonry-component";
import 'moment/locale/zh-cn';
import { inspiration_es_batchDelColl, inspiration_es_batchDelIns, fetchCollDetail, popDetail } from '../../../../api/inspiration';
import { SimpleImg } from 'react-simple-img';
import { imgSuffix } from '../../../../util/inspiration';
import './index.less';

const masonryOptions = {
  transitionDuration: 0,
};
const imagesLoadedOptions = { background: ".my-bg-image-el" };

export default React.memo(function CheckModal(props) {
  const { modalVisible, onCancel, onOk, collId } = props;
  const [isLoading, setLoading] = useState(false);
  const [detailList, setDetailList] = useState([]);
  const [collName, setCollName] = useState('');
  const [description, setDescription] = useState('');
  const [collInfo, setCollInfo] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAllSelected, setAllSelected] = useState(false);
  // 悬浮pop信息
  const [popData, setPopData] = useState({})


  useEffect(() => {
    if (collId && modalVisible) {
      setDetailList([]);
      setCollInfo(null);
      getImgList();
    }
  }, [collId, modalVisible]);

  useEffect(() => {
    setCollName(collInfo?.collName ?? '');
    setDescription(collInfo?.description ?? '');
  }, []);

  useEffect(() => {
    if (selectedIds.length != 0 && detailList.length != 0 && selectedIds.length == detailList.length && !isAllSelected) {
      setAllSelected(true);
    } else if ((selectedIds.length != detailList.length || selectedIds.length == 0 || detailList.length == 0) && isAllSelected) {
      setAllSelected(false);
    }
  }, [selectedIds]);

  const getImgList = async () => {
    setDetailList([]);
    setLoading(true);
    const res = await fetchCollDetail({ collId });
    if (res?.error?.code == 0 && res?.data) {
      setCollInfo({
        collName: res.data?.collName ?? '',
        description: res.data?.description ?? ''
      });
      setDetailList(res.data?.insList ?? []);
    }
    setLoading(false);
  };

  const onImgClick = v => {
    let index = selectedIds.indexOf(v.insId);
    if (index != -1) {
      selectedIds.splice(index, 1);
      setSelectedIds([...selectedIds]);
    } else {
      setSelectedIds([...selectedIds, v.insId]);
    }
  };

  const del_collIds = async () => {
    message.loading("删除中...", 0);
    await inspiration_es_batchDelColl([collId])
      .then((res) => {
        if (res.data.error.code === 0) {
          message.destroy();
          success(res.data.data)
        } else {
          message.error(res.data.data);
        }
      })
      .catch(() => {
        message.destroy();
        message.error("数据格式错误");
      });
    onOk();
  };

  const del_insIds = async () => {
    message.loading("删除中...", 0);
    await inspiration_es_batchDelIns(selectedIds)
      .then((res) => {
        if (res.data.error.code === 0) {
          message.destroy();
          success(res.data.data);
        } else {
          message.error(res.data.data);
        }
      })
      .catch(() => {
        message.destroy();
        message.error("数据格式错误");
      });
    onOk();
  };

  const success = (data) => {
    Modal.success({
      content: '处理完毕!'
    });
  };

  const onVisibleChange = async (insId) => {
    const res = await popDetail(insId)
    setPopData(res.data)
  }

  return (
    <Modal
      width={1460}
      centered={true}
      visible={modalVisible}
      wrapClassName={'atlas_modal_wrap'}
      footer={
        <div>
          <Button type="primary" onClick={del_insIds}>
            删除图片
          </Button>
          <Button type="primary" onClick={del_collIds}>删除图集</Button>
        </div>
      }
      onCancel={onCancel}
    >
      <Spin spinning={isLoading}>
        <div className='header'>
          {/* <span>标题:</span> */}
          <span style={{ maxWidth: 300, margin: '0 auto' }}>{collInfo?.collName ?? '暂无'}</span>
          {/* <span style={{ marginLeft: 30 }}>描述:</span>
          <span style={{ maxWidth: 300, marginLeft: 10 }}>{collInfo?.description ?? '暂无'}</span> */}
        </div>
        <Masonry
          elementType={"ul"}
          options={masonryOptions}
          disableImagesLoaded={false}
          updateOnEachImageLoad={false}
          imagesLoadedOptions={imagesLoadedOptions}
        >
          {detailList && detailList.length ?
            detailList.map((item, index) => {
              const height = Math.floor((250 * item.height) / item.width);
              return (
                <Popover onVisibleChange={(visible) => visible && onVisibleChange(item.insId)} arrowPointAtCenter={true} content={
                  <div className="autoResponsiveItemPopover">
                    <p>图片得分：{popData.score ?? '无'}</p>
                    <p>ID：{popData.insId}</p>
                    <p style={{ whiteSpace: 'pre-wrap' }}>标签：{popData.tags || '无'}</p>
                    <p style={{ wordBreak: 'break-all' }}>原始标题：{popData.titleOrigin || '无'}</p>
                    <p>来源网站：{popData.website}</p>
                    <p>入库时间：{popData.updateTime}</p>
                    <p>原尺寸：{popData.size}</p>
                    <p style={{ wordBreak: 'break-all' }}>图片url：{popData.url}</p>
                  </div>
                }>
                  <li
                    key={index}
                    className="atlasManager_iamgeItem"
                    onClick={() => onImgClick(item)}
                  >
                    <SimpleImg className='waterFall_item_img_wrap' height={height} src={(item.cover || item.img) + imgSuffix(250, height)} />
                    <div className={`mask ${selectedIds.includes(item.insId) && 'mask_show'}`}>
                      <div className='triangle' />
                      <Icon type='check' className='check' />
                    </div>
                  </li>
                </Popover>
              );
            }) : <span>无搜索结果</span>}
        </Masonry>
      </Spin>
    </Modal>
  )
})